import { atom } from "jotai";

import { DiningBookingWizard } from "../../../types";
import {
  DiningBookingKnownPeopleAtom,
  DiningBookingWizardDataAtom,
} from "../../stores";

export const addKnownDiningPersonAtom = atom(
  null,
  (get, set, person: DiningBookingWizard.DiningBookingKnownPerson) => {
    const wizardData = get(DiningBookingWizardDataAtom);
    const knownPeople = get(DiningBookingKnownPeopleAtom);

    if (!wizardData) {
      return;
    }

    const existingIndex = knownPeople.findIndex(
      (existing) => existing.playerId === person.playerId
    );

    const groupIsFull = knownPeople.length >= wizardData.partySize;

    if (existingIndex !== -1 || groupIsFull) {
      return;
    }

    const updatedKnownPeople = [...knownPeople, person];
    set(DiningBookingKnownPeopleAtom, updatedKnownPeople);

    const otherKnownIds = updatedKnownPeople
      .map((knownPerson) => knownPerson.playerId)
      .filter((playerId) => playerId !== wizardData.ownerId);

    set(DiningBookingWizardDataAtom, {
      ...wizardData,
      otherPatronIds: otherKnownIds,
    });
  }
);
